const SvgRegisterCheckmark = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 200 200" {...props}>
        <path
            fill="none"
            stroke="#B3DFD8"
            stroke-miterlimit="10"
            stroke-width="10"
            d="m126.52 62.01-37.89 68.27-18.85-15.51"
        />
        <circle
            cx="100.5"
            cy="100.5"
            r="100"
            fill="none"
            stroke="#b5e3d8"
            strokeMiterlimit="10"
        />
    </svg>
);

export default SvgRegisterCheckmark;
